import { Input as AntInput } from 'antd'
import type { ComponentProps } from 'react'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

type AntSearchProps = ComponentProps<typeof AntInput.Search>

export interface AppSearchInputProps extends Omit<AntSearchProps, 'size'> {
  size?: Size
}

export const AppSearchInput = ({ size = 'md', ...rest }: AppSearchInputProps) => (
  <AntInput.Search size={SIZE_MAP[size]} {...rest} />
)
